import { QTableColumn } from 'pansx-utils';

export class TimeAssistantFeedback {
    public id?: number;
    public timeAssistantId = 0;
    public username = '';
    public url = '';
    public name = '';
    public feedback = '';
    timeStamp = Date.parse(new Date().toString());//唯一的时间戳
    time = TimeAssistantFeedback.formatDate(this.timeStamp);

    static formatDate(timeStamp: number) {
        const date = new Date(timeStamp);
        const year = date.getFullYear();
        /* 在日期格式中，月份是从0开始的，因此要加0
         * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
         * */
        const month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
        const day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        const hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        const minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        // const seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
        return year + "-" + month + "-" + day + " " + hours + ":" + minutes;
    }

    public static of(o: unknown): TimeAssistantFeedback {
        return Object.assign(new TimeAssistantFeedback(), o);
    }
    public static getColumns(): QTableColumn[] {
        return [
            { name: 'id', field: 'id', label: '序号' },
            {
                name: 'timeAssistantId',
                field: 'timeAssistantId',
                label: '时间助理id',
            },
            { name: 'username', field: 'username', label: '用户名' },
            { name: 'url', field: 'url', label: '网址' },
            { name: 'name', field: 'name', label: '名称' },
            { name: 'feedback', field: 'feedback', label: '反馈' },
            { name: 'time', field: 'time', label: '时间' },
        ];
    }
    public getColumnLabel(field: string) {
        const columns = TimeAssistantFeedback.getColumns();
        const find: QTableColumn | undefined = columns.find(
            (value) => value.field === field
        );
        if (typeof find !== 'undefined') {
            return find.label;
        }
        return '';
    }
}
